import request from 'utils/request'
import api from 'common/api/channels'
import {format} from '@/utils'

export async function allChannels() {
    return request(api.allChannels.url)
}

// 商家渠道：不包含默认，活动裂变
export async function businessChannels() {
    return request(api.businessChannels.url)
}

// 创建渠道
export async function addChannel(payload) {
    return request(api.addChannel.url, {
        method: api.addChannel.type,
        body: payload.body,
    })
}

// 编辑渠道
export async function editChannel(payload) {
    return request(format(api.editChannel.url, {id: payload.id}), {
        method: api.editChannel.type,
        body: payload.body,
    })
}
